import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import mediumZoom from 'medium-zoom';

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  grid-auto-rows: minmax(220px, 320px);
  grid-gap: 40px;
`;

const ImageWrapper = styled.picture`
  width: 100%;
  height: 100%;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  /* min-height: 100%;
  min-width: 100%; */
  object-fit: contain;

  /* &.medium-zoom-image--opened {
    object-fit: contain;
  } */
`;

const ImageGallery = ({ images, ...rest }) => {
  const imageRefs = useRef(
    // eslint-disable-next-line no-unused-vars
    [...Array(images.length)].map(_ => React.createRef())
  );

  const zoom = useRef(null);

  useEffect(() => {
    zoom.current = mediumZoom(imageRefs.current, {
      margin: 25,
      scrollOffset: 0,
      background: 'rgba(255, 255, 255, 0.8)',
    });

    return () => {
      zoom.current.detach();
    };
  }, [imageRefs]);

  return (
    <Grid {...rest}>
      {images.map(({ zdjecie }, index) => (
        <ImageWrapper key={index}>
          <Image
            src={zdjecie.localFile.childImageSharp.fluid.src}
            alt={zdjecie.alt}
            // srcSet={zdjecie.localFile.childImageSharp.fluid.srcSet}
            ref={el => (imageRefs.current[index] = el)}
            css="max-width: 100%; max-height: 100%;"
            data-zoomable
          />
        </ImageWrapper>
      ))}
    </Grid>
  );
};

ImageGallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ImageGallery;
